import type { VersionInfo } from "./api";

// Before a portal "Upload new version", warn when the current version was
// uploaded by someone else. A portal upload comes from a file on the user's
// machine, and nothing tells us whether that file includes the other person's
// latest edits — a collaborator re-uploading an old local copy silently wipes
// them out. Returns the confirm() text, or null when there's nothing to warn about.
export function staleUploadWarning(versions: VersionInfo[], me: string | null): { latest: number; message: string } | null {
  const latest = versions
    .filter((v) => v.status !== "failed" && v.status !== "deleted")
    .reduce<VersionInfo | null>((a, v) => (!a || v.version > a.version ? v : a), null);
  if (!latest) return null;
  // Same rule as the API: only the user's own sign-in upload is "mine". A
  // token upload's uploadedBy is whatever the uploader typed, so it can't vouch.
  if (me && latest.authMethod === "oidc" && latest.uploadedBy === me) return { latest: latest.version, message: "" };
  const when = new Date(latest.uploadedAt).toLocaleString();
  return {
    latest: latest.version,
    message:
      `The current version (v${latest.version}) was uploaded by ${latest.uploadedBy} on ${when}.\n\n` +
      "If your file was made from an older copy, uploading it will wipe out their changes. " +
      "Download the current version first and make sure your file includes their edits.\n\n" +
      "Upload anyway?",
  };
}
